import { render, staticRenderFns } from "./route-info.vue?vue&type=template&id=5d596a79"
import script from "./route-info.vue?vue&type=script&lang=js"
export * from "./route-info.vue?vue&type=script&lang=js"
import style0 from "./route-info.vue?vue&type=style&index=0&id=5d596a79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports